<div class="panel-button"
  [class]="{'tall': isTall == true, 'disabled': isDisabled == true, 'noMaxHeight': noMaxHeight}">
  <table>
    <tr>
      <td><div class="label">{{label}}</div></td>
      <td rowspan="2" style="width: 22px;"><div class="chevron">@if (!supressIcon) {
        <fa-icon [icon]="faChevronRight"></fa-icon>
      }</div></td>
    </tr>
    <tr><td><div class="content"><ng-content></ng-content></div></td></tr>
  </table>
</div>
